import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  key:'reports.ordersummarybyday',
  path: '/reports/order-summary-by-day',
    title: 'Open Order Summary by Day',
    component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);